import { render } from "./global-events-handler.vue?vue&type=template&id=504c41d9"
import script from "./global-events-handler.vue?vue&type=script&lang=js"
export * from "./global-events-handler.vue?vue&type=script&lang=js"
script.render = render

export default script